<template>
    <div class="public-personal-center">
        <div class="left-menu">
            <img style="margin: 0 auto;display:block;margin-top:32px;" src="../../assets/img/logo.png" alt="">
            <div style="padding-top:10px;font-weight:bold;color:rgba(18, 18, 18, 1);text-align:center;">
                {{systemInfoData.serviceProviderName}}
            </div>
            <div style="text-align:center;margin:8px auto 24px">
                <span @click="goBack" style="display:inline-block;width:88px;height:26px;text-align:center;line-height:26px;color:rgba(0, 0, 0, 1);font-size:12px;background:rgba(240, 242, 243, 0.7);cursor:pointer;">返回工作台</span>
            </div>
            <a-menu
                style="width: 199px"
                :default-selected-keys="['PersonalInfo']"
                :default-open-keys="['sub1']"
                mode="inline"
                :theme="theme"
                :selected-keys="[current]"
                @click="handleClick"
            >
                <a-menu-item v-for="(item,index) in menuList" :key="index">
                    <router-link :to="'/'+item.component">
                        <i style="margin-right:7px;" class="iconfont" :class="item.icon"></i>
                        {{item.title}}
                    </router-link>
                </a-menu-item>
            </a-menu>
        </div>
        <div class="right-content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PublicMenu',
        data() {
            return {
                current: 'PersonalInfo',
                theme: 'light',
                menuList: [],
                systemInfoData: ''
            }
        },
        methods: {
            handleClick(e) {
                this.current = e.key;
                sessionStorage.setItem('menuKey', e.key)
            },
            goAuthenticate() {
                sessionStorage.setItem('menuKey', 'RoleInfo')
                this.$router.push("/RoleInfo")
                this.current = 'RoleInfo'
            },
            goBack() {
                this.sessionData('set','currentTab', 2);
                this.$router.push("/MailList")
            },
            queryBasicInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/menu/personalCenterMenuList', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.menuList = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
            querySystemInfo() {
                this.axios(
                    {
                        method:'get',
                        url:'/api/serviceProviderUser', 
                    }
                )
                .then(response=> {
                    if(response.data.code == 0){
                        this.systemInfoData = response.data.data
                    }else{
                        this.$message.error(response.data.userTip);
                    }
                })
                .catch(error=> {
                    console.log(error)
                })
            },
        },
        mounted: function() {
            if(sessionStorage.getItem('menuKey')){
                this.current = sessionStorage.getItem('menuKey')
            }
            this.queryBasicInfo()
            this.querySystemInfo()
        },
    }
</script>

<style scoped lang="less">
    .public-personal-center{
        display: flex;
        width: 100%;
        height: 100%;
        background: rgba(240, 242, 243, 1);
        position: relative;
        .left-menu{
            width: 200px;
            height: 100%;
            background: #fff;
            // border-right: 1px solid rgba(229, 229, 229, 1);
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            z-index: 999;
        }
        .right-content{
            flex: 1;
            height: 100%;
        }
    }
</style>